import * as React from "react";
import { AuthContext, IAuthContextState } from "../auth-context";
import { RecoveryLoginDialog } from "./recovery-login-dialog";
import { UserLevel } from "../model/autogen/UserLevel";
import { Iif } from "./iif";
import { Content } from "./content";
import Paper from "@material-ui/core/Paper/Paper";

export type IFetcher = (url: string, init: RequestInit) => Promise<Response>;

export interface IUserDetails {
    level: UserLevel,
    id: string | null // guid
}
export interface IAuthContextProps {
    user: IUserDetails;

    callApi: <T>(serviceMethod: (fetcher: IFetcher) => Promise<T>) => Promise<T>;
}

export type Omit<T, K extends keyof T> = Pick<T, ({ [P in keyof T]: P } & { [P in K]: never } & { [x: string]: never, [x: number]: never })[keyof T]>;

const PermissionDenied = (props: any) => <Content>
    <Paper>
        <Content>
            <h1 className="perm-denied-title">Sorry, permission denied.</h1>
            <p className="perm-denied-message">Your user account doesn't have access to this function</p>
        </Content>
    </Paper>
</Content>;

export const withAuthContext = <P extends object>(Component: React.ComponentType<P & IAuthContextProps>, minLevel?: UserLevel, minExclusive?: boolean) =>
    class WithAuthContext extends React.Component<Omit<P & IAuthContextProps, keyof IAuthContextProps>> {
        render(): JSX.Element {
            const showMe = minExclusive === true
                ? (state: IAuthContextState) => typeof (minLevel) === 'undefined' || state.user.level > minLevel
                : (state: IAuthContextState) => typeof (minLevel) === 'undefined' || state.user.level >= minLevel;
            return <AuthContext.Consumer>
                {({ state, methods }) => (
                    <>
                        <Iif show={showMe(state)} else={<PermissionDenied />}>
                            <Component {...this.props as any} callApi={methods.invokeApi} user={state.user} />
                        </Iif>
                        {!state.token && <RecoveryLoginDialog recoveryLoginAction={methods.recoveryLogin} />}
                    </>
                )}
            </AuthContext.Consumer>;
        }
    };



// WEBPACK FOOTER //
// ./src/components/with-auth-context.tsx